import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, Input, OnInit, Renderer2, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DEMO_MENU } from '@appNeo/pages/configuracion/menu-data';

export interface IConfiguracionButtonCta {
  url?: string,
  path?:string, // routing interno
  target?: boolean,
  iconoClase?: string,
  icono?: string,
  label?: string,
  otroUso: boolean
}

@Component({
  selector: 'neo-main-header [elementosMenu]',
  templateUrl: './main-header.component.html',
  styleUrls: ['./main-header.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MainHeaderComponent implements OnInit {

  @Input() elementosMenu;
  @Input() float: string = 'mainHeader-float';
  @Input() normalStyle: string  = 'negative';
  @Input() stickyStyle: string  = 'color';
  @Input() burgerStyle : string = 'color';
  @Input() menuInline : boolean = true;

  // cta
  @Input() buttonCta: boolean = true;
  @Input() configuracionButtonCta: IConfiguracionButtonCta = { otroUso: false };

  @Input() menuUser : boolean = true;
  @Input() menuIdiomas : boolean = true;
  @Input() menuBurger : boolean = true;

  @Input() customProyeccion: TemplateRef<any>;
  mainHeaderScroll;
  mainHeaderOrigin;
  elementosIdioma = [
    {
        nombre: 'Esp',
        codigo: 'es',
        url: '#',
        hijos: [
            {
                nombre: 'Esp',
                codigo: 'es',
                // url: 'http://htdocs.local/unef-matrix/es/',
                url: '#'
            },
            {
                nombre: 'Eng',
                codigo: 'en',
                // url: 'http://htdocs.local/unef-matrix/en/',
                url: '#'
            },
            {
              nombre: 'Gl',
              codigo: 'gl',
              // url: 'http://htdocs.local/unef-matrix/en/',
              url: '#'
            }
        ]
    }];

  @HostListener('window:scroll', [])
  onWindowScroll() {
   this.mainHeaderHandler(false);
  }

  @ViewChild('dialogoInformacionUE') dialogoInformacionUE: TemplateRef<any>;

  constructor(
    private element: ElementRef,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.mainHeaderInit();
  }

  ngAfterViewInit() {
    if (this.buttonCta && this.configuracionButtonCta.otroUso) {
      if ((!this.configuracionButtonCta?.url && !this.configuracionButtonCta?.path)
        || !this.configuracionButtonCta?.label
      ) {
        throw new Error("[ERROR DE CONFIGURACION COMPONENTE NEO ][MAIN-HEADER] Configurado de forma incorrecta el mainCta para otroUso");
      }
    }
  }

  private mainHeaderInit() {
    this.mainHeaderScroll = 0;
    this.mainHeaderOrigin = 0;
    this.mainHeaderHandler(true);
  }

  private mainHeaderHandler(primeraCarga: boolean){
    const mainHeader: HTMLElement = this.element.nativeElement;

    const scrollTop =
      // this.window.pageYOffset ||
      this.document.documentElement.scrollTop ||
      this.document.body.scrollTop ||
      0;
    if (mainHeader) {
      if (scrollTop) {
        // si hay scroll, se juega con el sticky
        const mainHeaderHeight = mainHeader?.offsetHeight;
        if( scrollTop > this.mainHeaderScroll) {
          // console.log('MainHeaderScroll ', this.mainHeaderScroll, 'mainHeaderHeight =>', mainHeaderHeight);
          if (primeraCarga) {
            // si es la carga inicial, aparece el header
            this.renderer.removeClass(mainHeader, 'mainHeaderNormal');
            this.renderer.addClass(mainHeader, 'mainHeaderSticky');
          } else if(this.mainHeaderScroll > mainHeaderHeight){
            // si no, al ir hacia abajo, el menu desapareceç
            this.mainHeaderOrigin = 0;
            this.renderer.addClass(mainHeader, 'mainHeaderSticky-off')
          }
        } else if (this.mainHeaderScroll > mainHeaderHeight) {
           // al ir hacia arriba, sólo aparece el header al hacer un desplazamiento minimo de mainHeaderHeight
          if (this.mainHeaderOrigin == 0) {
            this.mainHeaderOrigin = this.mainHeaderScroll;
          }
          if (this.mainHeaderOrigin - scrollTop > mainHeaderHeight) {
              this.renderer.removeClass(mainHeader, 'mainHeaderNormal');
              this.renderer.addClass(mainHeader, 'mainHeaderSticky');
              this.renderer.removeClass(mainHeader, 'mainHeaderSticky-off');
          }
        }
      } else {
        // si no hay scroll, se vuelve al estado normal
        this.renderer.removeClass(mainHeader, 'mainHeaderSticky');
        this.renderer.removeClass(mainHeader, 'mainHeaderSticky-off');
        this.renderer.addClass(mainHeader, 'mainHeaderNormal');
      }
      this.mainHeaderScroll = scrollTop;
    }
  }


  verInformacionUE() {
    this.dialog.open(this.dialogoInformacionUE, { panelClass: 'dialogoInformacionUE', width: '700px'});
  }

}
